import { BOOKED_APPOINTMENT_CLEAR } from '../constants/bookedAppointmentTypes';

export function bookedAppointmentClear() {
  return { type: BOOKED_APPOINTMENT_CLEAR };
}



// WEBPACK FOOTER //
// ./app/actions/bookedAppointmentActions.js